'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { usePathname } from 'next/navigation';
import { parseDrawId } from '../../../../core/lib/entry.browser.js';
/**
 * Wrapper component for the DrawSelectorCardList that handles the navigation logic.
 *
 * @param root0 The component props
 * @param root0.children The child components to render, typically the list of draw cards
 * @param root0.basePath The base path for the draw links
 * @param root0.drawNumber The currently selected draw number to determine active state
 * @param root0.definition The game definition, used to parse the correct query parameters for the links
 * @returns The rendered child components with navigation handling
 */
export function DrawSelectorCardListWrapper({ children, basePath, drawNumber, definition, }) {
    const pathname = usePathname();
    const segments = pathname.split('/').filter(Boolean);
    // Build href based on segments validation
    let href = `${basePath}/${drawNumber}`;
    const [, secondSegment, thirdSegment] = segments;
    if (secondSegment) {
        // Check if second segment is a valid drawNumber (numeric)
        try {
            const { drawNumber: parsedDrawNumber } = parseDrawId(secondSegment, definition);
            const isDrawNumber = parsedDrawNumber !== 'defaultDrawId';
            if (!isDrawNumber) {
                href = `${href}/${secondSegment}`;
            }
            if (isDrawNumber && thirdSegment) {
                href = `${href}/${thirdSegment}`;
            }
        }
        catch {
            // second segment is not a valid drawNumber, treat it as a static segment
            href = `${href}/${secondSegment}`;
        }
    }
    return _jsx("a", { href: href, children: children });
}
//# sourceMappingURL=DrawSelector.CardListWrapper.js.map